export default "__VITE_ASSET__314b71a6__"